import { HappyHoursPeriodModel } from './happy-hours.model';
import { Duration } from 'moment';

export class HappyHoursPeriodNowModel extends HappyHoursPeriodModel {
  public get timeLeft(): Duration {
    return this.timeLeftBeforeEnd;
  }
}
